export enum MotiveExceptionType {
  EMPLOYEE = 1,
  LOCATION = 2,
}

interface IMotiveException {
  id: number;
  companyId: number;
  type: MotiveExceptionType;
  contractMotiveId: number;
  attempt?: number | null;
  startDate: string;
  endDate?: string | null;
  targetIds: number[];
}

export default IMotiveException;
